var map = {
	"./IMG_2557.PNG": 162,
	"./JR_chair.png": 163,
	"./Minotaur.png": 164,
	"./NotMinotaur.png": 165,
	"./Screenshot_20210828-083538.png": 166,
	"./Screenshot_20210828-084319.png": 167,
	"./Secrets/ToEveryoneFromTLViaJR.pdf": 168,
	"./Secrets/can_we_pretend_like_airpla.png": 169,
	"./Secrets/creeper_map.png": 170,
	"./Secrets/dm_gorgon.gif": 171,
	"./Secrets/feedback.png": 172,
	"./Secrets/how_much_do_you_think_waffles_cost/0": 116,
	"./Secrets/how_much_do_you_think_waffles_cost/0.js": 116,
	"./Secrets/how_much_do_you_think_waffles_cost/0.png": 173,
	"./Secrets/how_much_do_you_think_waffles_cost/1.jpg": 174,
	"./Secrets/no.jpg": 175,
	"./Secrets/plant_more_trees/0": 117,
	"./Secrets/plant_more_trees/0.js": 117,
	"./Secrets/plant_more_trees/0.png": 176,
	"./Secrets/plant_more_trees/1.png": 177,
	"./Secrets/starlight.png": 178,
	"./Secrets/the_end_is_never_the_end/0": 118,
	"./Secrets/the_end_is_never_the_end/0.js": 118,
	"./Secrets/the_end_is_never_the_end/0.png": 179,
	"./Secrets/the_end_is_never_the_end/1.jpg": 180,
	"./Secrets/the_truth_is_layered/0": 119,
	"./Secrets/the_truth_is_layered/0.js": 119,
	"./Secrets/the_truth_is_layered/0.png": 181,
	"./Secrets/the_truth_is_layered/1.PNG": 182,
	"./Secrets/unknown.png": 183,
	"./Secrets/you_is_needed_to_end_the_world/0": 120,
	"./Secrets/you_is_needed_to_end_the_world/0.js": 120,
	"./Secrets/you_is_needed_to_end_the_world/0.png": 184,
	"./Secrets/you_is_needed_to_end_the_world/1.jpg": 185,
	"./Secrets/zampanino.txt": 186,
	"./Secrets/zampiano.txt": 187,
	"./Untitled_Artwork 2.png": 188,
	"./Untitled_Artwork.png": 189,
	"./Walkabout/Objects/BackWallObjects/bees.png": 190,
	"./Walkabout/Objects/BackWallObjects/bees2.png": 191,
	"./Walkabout/Objects/BackWallObjects/bees3.png": 192,
	"./Walkabout/Objects/BackWallObjects/bees4.png": 193,
	"./Walkabout/Objects/BackWallObjects/blackboard.png": 194,
	"./Walkabout/Objects/BackWallObjects/bloodywall.png": 195,
	"./Walkabout/Objects/BackWallObjects/decayingwall.png": 196,
	"./Walkabout/Objects/BackWallObjects/lockers.png": 197,
	"./Walkabout/Objects/BackWallObjects/wallcrack.png": 198,
	"./Walkabout/Objects/BackWallObjects/wallhole.png": 199,
	"./Walkabout/Objects/BackWallObjects/wallholebig.png": 200,
	"./Walkabout/Objects/BackWallObjects/webclock.png": 201,
	"./Walkabout/Objects/BackWallObjects/webmirror.png": 202,
	"./Walkabout/Objects/BackWallObjects/webpainting.png": 203,
	"./Walkabout/Objects/BackWallObjects/webpainting2.png": 204,
	"./Walkabout/Objects/BackWallObjects/webpainting3.png": 205,
	"./Walkabout/Objects/Bloodytilesets(editrecolourbyCvrtis).1448356728.png": 206,
	"./Walkabout/Objects/FrontWallObjects/Web_Object.png": 207,
	"./Walkabout/Objects/FrontWallObjects/bees.png": 208,
	"./Walkabout/Objects/FrontWallObjects/bees2.png": 209,
	"./Walkabout/Objects/FrontWallObjects/bees3.png": 210,
	"./Walkabout/Objects/FrontWallObjects/bees4.png": 211,
	"./Walkabout/Objects/FrontWallObjects/bookshelves.png": 212,
	"./Walkabout/Objects/FrontWallObjects/clock.png": 213,
	"./Walkabout/Objects/FrontWallObjects/clock2.png": 214,
	"./Walkabout/Objects/FrontWallObjects/closed_vent.png": 215,
	"./Walkabout/Objects/FrontWallObjects/curtains.png": 216,
	"./Walkabout/Objects/FrontWallObjects/deadvines.png": 217,
	"./Walkabout/Objects/FrontWallObjects/decayingwindow.png": 218,
	"./Walkabout/Objects/FrontWallObjects/dress.png": 219,
	"./Walkabout/Objects/FrontWallObjects/drippingblood.png": 220,
	"./Walkabout/Objects/FrontWallObjects/eye1.png": 221,
	"./Walkabout/Objects/FrontWallObjects/eye10.png": 222,
	"./Walkabout/Objects/FrontWallObjects/eye11.png": 223,
	"./Walkabout/Objects/FrontWallObjects/eye12.png": 224,
	"./Walkabout/Objects/FrontWallObjects/eye13.png": 225,
	"./Walkabout/Objects/FrontWallObjects/eye2.png": 226,
	"./Walkabout/Objects/FrontWallObjects/eye3.png": 227,
	"./Walkabout/Objects/FrontWallObjects/eye4.png": 228,
	"./Walkabout/Objects/FrontWallObjects/eye5.png": 229,
	"./Walkabout/Objects/FrontWallObjects/eye6.png": 230,
	"./Walkabout/Objects/FrontWallObjects/eye7.png": 231,
	"./Walkabout/Objects/FrontWallObjects/eye8.png": 232,
	"./Walkabout/Objects/FrontWallObjects/eye9.png": 233,
	"./Walkabout/Objects/FrontWallObjects/fireplace.png": 234,
	"./Walkabout/Objects/FrontWallObjects/flowervines.png": 235,
	"./Walkabout/Objects/FrontWallObjects/grate.png": 236,
	"./Walkabout/Objects/FrontWallObjects/herald.png": 237,
	"./Walkabout/Objects/FrontWallObjects/landscape.png": 238,
	"./Walkabout/Objects/FrontWallObjects/laundry.png": 239,
	"./Walkabout/Objects/FrontWallObjects/lightswitch.png": 240,
	"./Walkabout/Objects/FrontWallObjects/lonely_figure.png": 241,
	"./Walkabout/Objects/FrontWallObjects/map.png": 242,
	"./Walkabout/Objects/FrontWallObjects/mirror.png": 243,
	"./Walkabout/Objects/FrontWallObjects/mirror2.png": 244,
	"./Walkabout/Objects/FrontWallObjects/net.png": 245,
	"./Walkabout/Objects/FrontWallObjects/open_vent.png": 246,
	"./Walkabout/Objects/FrontWallObjects/picture_of_king.png": 247,
	"./Walkabout/Objects/FrontWallObjects/picture_of_woman.png": 248,
	"./Walkabout/Objects/FrontWallObjects/picture_of_woman2.png": 249,
	"./Walkabout/Objects/FrontWallObjects/questboard.png": 250,
	"./Walkabout/Objects/FrontWallObjects/rotted_curtains1.png": 251,
	"./Walkabout/Objects/FrontWallObjects/rotted_curtains2.png": 252,
	"./Walkabout/Objects/FrontWallObjects/rotted_curtains3.png": 253,
	"./Walkabout/Objects/FrontWallObjects/shield.png": 254,
	"./Walkabout/Objects/FrontWallObjects/shield2.png": 255,
	"./Walkabout/Objects/FrontWallObjects/smallstainedglasswindow.png": 256,
	"./Walkabout/Objects/FrontWallObjects/stainedglasswindow.png": 257,
	"./Walkabout/Objects/FrontWallObjects/stilllife.png": 258,
	"./Walkabout/Objects/FrontWallObjects/swords.png": 259,
	"./Walkabout/Objects/FrontWallObjects/vines.png": 260,
	"./Walkabout/Objects/FrontWallObjects/vines2.png": 261,
	"./Walkabout/Objects/FrontWallObjects/vines3.png": 262,
	"./Walkabout/Objects/FrontWallObjects/waspnest.png": 263,
	"./Walkabout/Objects/FrontWallObjects/waspnest2.png": 264,
	"./Walkabout/Objects/FrontWallObjects/webbing.png": 265,
	"./Walkabout/Objects/FrontWallObjects/webbing2.png": 266,
	"./Walkabout/Objects/FrontWallObjects/webbing3.png": 267,
	"./Walkabout/Objects/FrontWallObjects/webbing4.png": 268,
	"./Walkabout/Objects/FrontWallObjects/webbing5.png": 269,
	"./Walkabout/Objects/FrontWallObjects/webcurtains.png": 270,
	"./Walkabout/Objects/FrontWallObjects/webcurtains2.png": 271,
	"./Walkabout/Objects/TopFloorObjects/Addiction_Object.png": 272,
	"./Walkabout/Objects/TopFloorObjects/Angel_Object.png": 273,
	"./Walkabout/Objects/TopFloorObjects/Anger_Object.png": 274,
	"./Walkabout/Objects/TopFloorObjects/Apocalypse_Object.png": 275,
	"./Walkabout/Objects/TopFloorObjects/Buried_Object.png": 276,
	"./Walkabout/Objects/TopFloorObjects/Choice_Object.png": 277,
	"./Walkabout/Objects/TopFloorObjects/Clown_Object.png": 278,
	"./Walkabout/Objects/TopFloorObjects/Crafting_Object.png": 279,
	"./Walkabout/Objects/TopFloorObjects/Death_Object.png": 280,
	"./Walkabout/Objects/TopFloorObjects/Decay_Object.png": 281,
	"./Walkabout/Objects/TopFloorObjects/Dolls_Object.png": 282,
	"./Walkabout/Objects/TopFloorObjects/Ending_Object.png": 283,
	"./Walkabout/Objects/TopFloorObjects/Endings_Object_2.png": 284,
	"./Walkabout/Objects/TopFloorObjects/Family_Object.png": 285,
	"./Walkabout/Objects/TopFloorObjects/Fire_Object.png": 286,
	"./Walkabout/Objects/TopFloorObjects/Flesh_Object.png": 287,
	"./Walkabout/Objects/TopFloorObjects/Flesh_Object2.png": 288,
	"./Walkabout/Objects/TopFloorObjects/Freedom_Object.png": 289,
	"./Walkabout/Objects/TopFloorObjects/Guiding_Object.png": 290,
	"./Walkabout/Objects/TopFloorObjects/Healing_Object.png": 291,
	"./Walkabout/Objects/TopFloorObjects/JadedResearcher.png": 292,
	"./Walkabout/Objects/TopFloorObjects/Knowing_Object.png": 293,
	"./Walkabout/Objects/TopFloorObjects/Light_Object.png": 294,
	"./Walkabout/Objects/TopFloorObjects/Love_Object.png": 295,
	"./Walkabout/Objects/TopFloorObjects/Magic_Object.png": 296,
	"./Walkabout/Objects/TopFloorObjects/Math_Object.png": 297,
	"./Walkabout/Objects/TopFloorObjects/Ocean_Object_1.png": 298,
	"./Walkabout/Objects/TopFloorObjects/Ocean_Object_2.png": 299,
	"./Walkabout/Objects/TopFloorObjects/Plants_Object1.png": 300,
	"./Walkabout/Objects/TopFloorObjects/Plants_Object2.png": 301,
	"./Walkabout/Objects/TopFloorObjects/Royal_Object.png": 302,
	"./Walkabout/Objects/TopFloorObjects/Science_Object.png": 303,
	"./Walkabout/Objects/TopFloorObjects/Service_Object.png": 304,
	"./Walkabout/Objects/TopFloorObjects/Spirit_Object.png": 305,
	"./Walkabout/Objects/TopFloorObjects/Spirit_Object2.png": 306,
	"./Walkabout/Objects/TopFloorObjects/Stealing_Object.png": 307,
	"./Walkabout/Objects/TopFloorObjects/Twisting_Object.png": 308,
	"./Walkabout/Objects/TopFloorObjects/aluminum.png": 309,
	"./Walkabout/Objects/TopFloorObjects/angelstatue.png": 310,
	"./Walkabout/Objects/TopFloorObjects/arcanecrystals.png": 311,
	"./Walkabout/Objects/TopFloorObjects/arcanecrystals2.png": 312,
	"./Walkabout/Objects/TopFloorObjects/armor.png": 313,
	"./Walkabout/Objects/TopFloorObjects/armor2.png": 314,
	"./Walkabout/Objects/TopFloorObjects/armor3.png": 315,
	"./Walkabout/Objects/TopFloorObjects/balloon1.png": 316,
	"./Walkabout/Objects/TopFloorObjects/balloon2.png": 317,
	"./Walkabout/Objects/TopFloorObjects/balloon3.png": 318,
	"./Walkabout/Objects/TopFloorObjects/balloon4.png": 319,
	"./Walkabout/Objects/TopFloorObjects/balloon5.png": 320,
	"./Walkabout/Objects/TopFloorObjects/barrel.png": 321,
	"./Walkabout/Objects/TopFloorObjects/bear.png": 322,
	"./Walkabout/Objects/TopFloorObjects/beer.png": 323,
	"./Walkabout/Objects/TopFloorObjects/bees.png": 324,
	"./Walkabout/Objects/TopFloorObjects/bees2.png": 325,
	"./Walkabout/Objects/TopFloorObjects/bees3.png": 326,
	"./Walkabout/Objects/TopFloorObjects/bees4.png": 327,
	"./Walkabout/Objects/TopFloorObjects/bigbookshelf.png": 328,
	"./Walkabout/Objects/TopFloorObjects/bloodfountain.png": 329,
	"./Walkabout/Objects/TopFloorObjects/bonepile.png": 330,
	"./Walkabout/Objects/TopFloorObjects/books.png": 331,
	"./Walkabout/Objects/TopFloorObjects/boringbed.png": 332,
	"./Walkabout/Objects/TopFloorObjects/box.png": 333,
	"./Walkabout/Objects/TopFloorObjects/boxoknives.png": 334,
	"./Walkabout/Objects/TopFloorObjects/brownrocks.png": 335,
	"./Walkabout/Objects/TopFloorObjects/butcheredmeat.jpg": 336,
	"./Walkabout/Objects/TopFloorObjects/butcheredmeat.png": 337,
	"./Walkabout/Objects/TopFloorObjects/cabbages.png": 338,
	"./Walkabout/Objects/TopFloorObjects/cactus.png": 339,
	"./Walkabout/Objects/TopFloorObjects/cactus2.png": 340,
	"./Walkabout/Objects/TopFloorObjects/chessset.png": 341,
	"./Walkabout/Objects/TopFloorObjects/choppingblock.jpg": 342,
	"./Walkabout/Objects/TopFloorObjects/choppingblock.png": 343,
	"./Walkabout/Objects/TopFloorObjects/clock.png": 344,
	"./Walkabout/Objects/TopFloorObjects/cookingpot.png": 345,
	"./Walkabout/Objects/TopFloorObjects/corpse_blossom.png": 346,
	"./Walkabout/Objects/TopFloorObjects/deadbush.png": 347,
	"./Walkabout/Objects/TopFloorObjects/deadtree.png": 348,
	"./Walkabout/Objects/TopFloorObjects/decay_is_an_extant_form_of_life.png": 349,
	"./Walkabout/Objects/TopFloorObjects/decayedwebbox.png": 350,
	"./Walkabout/Objects/TopFloorObjects/decayingbarrel.png": 351,
	"./Walkabout/Objects/TopFloorObjects/doll.png": 352,
	"./Walkabout/Objects/TopFloorObjects/dollhouse.png": 353,
	"./Walkabout/Objects/TopFloorObjects/dress.png": 354,
	"./Walkabout/Objects/TopFloorObjects/drum.png": 355,
	"./Walkabout/Objects/TopFloorObjects/eye1.png": 356,
	"./Walkabout/Objects/TopFloorObjects/eye10.png": 357,
	"./Walkabout/Objects/TopFloorObjects/eye11.png": 358,
	"./Walkabout/Objects/TopFloorObjects/eye12.png": 359,
	"./Walkabout/Objects/TopFloorObjects/eye13.png": 360,
	"./Walkabout/Objects/TopFloorObjects/eye2.png": 361,
	"./Walkabout/Objects/TopFloorObjects/eye3.png": 362,
	"./Walkabout/Objects/TopFloorObjects/eye4.png": 363,
	"./Walkabout/Objects/TopFloorObjects/eye5.png": 364,
	"./Walkabout/Objects/TopFloorObjects/eye6.png": 365,
	"./Walkabout/Objects/TopFloorObjects/eye7.png": 366,
	"./Walkabout/Objects/TopFloorObjects/eye8.png": 367,
	"./Walkabout/Objects/TopFloorObjects/eye9.png": 368,
	"./Walkabout/Objects/TopFloorObjects/fancychest.png": 369,
	"./Walkabout/Objects/TopFloorObjects/fern.png": 370,
	"./Walkabout/Objects/TopFloorObjects/fishcrate.png": 371,
	"./Walkabout/Objects/TopFloorObjects/flowers.png": 372,
	"./Walkabout/Objects/TopFloorObjects/fossil1.png": 373,
	"./Walkabout/Objects/TopFloorObjects/fossil2.png": 374,
	"./Walkabout/Objects/TopFloorObjects/fossil3.png": 375,
	"./Walkabout/Objects/TopFloorObjects/fossil4.png": 376,
	"./Walkabout/Objects/TopFloorObjects/fossil5.png": 377,
	"./Walkabout/Objects/TopFloorObjects/fossil6.png": 378,
	"./Walkabout/Objects/TopFloorObjects/fossil7.png": 379,
	"./Walkabout/Objects/TopFloorObjects/gift.png": 380,
	"./Walkabout/Objects/TopFloorObjects/goldingots.png": 381,
	"./Walkabout/Objects/TopFloorObjects/grass.png": 382,
	"./Walkabout/Objects/TopFloorObjects/grave.png": 383,
	"./Walkabout/Objects/TopFloorObjects/guidepost.png": 384,
	"./Walkabout/Objects/TopFloorObjects/gumballmachine.png": 385,
	"./Walkabout/Objects/TopFloorObjects/ham.png": 386,
	"./Walkabout/Objects/TopFloorObjects/hammer.png": 387,
	"./Walkabout/Objects/TopFloorObjects/hatdummy.png": 388,
	"./Walkabout/Objects/TopFloorObjects/hobbyhorse.png": 389,
	"./Walkabout/Objects/TopFloorObjects/hospitalbed.png": 390,
	"./Walkabout/Objects/TopFloorObjects/hydration_station.png": 391,
	"./Walkabout/Objects/TopFloorObjects/hydrationstation2.png": 392,
	"./Walkabout/Objects/TopFloorObjects/hydrationstation3.png": 393,
	"./Walkabout/Objects/TopFloorObjects/iceglacier.png": 394,
	"./Walkabout/Objects/TopFloorObjects/jackinaboxclosed.png": 395,
	"./Walkabout/Objects/TopFloorObjects/jackinaboxopen.png": 396,
	"./Walkabout/Objects/TopFloorObjects/jars.png": 397,
	"./Walkabout/Objects/TopFloorObjects/jr_doll.png": 398,
	"./Walkabout/Objects/TopFloorObjects/jr_lobstersona.png": 399,
	"./Walkabout/Objects/TopFloorObjects/jr_slug.png": 400,
	"./Walkabout/Objects/TopFloorObjects/jwelerybox.png": 401,
	"./Walkabout/Objects/TopFloorObjects/knife.png": 402,
	"./Walkabout/Objects/TopFloorObjects/lamp.png": 403,
	"./Walkabout/Objects/TopFloorObjects/lamppost.png": 404,
	"./Walkabout/Objects/TopFloorObjects/laptop.png": 405,
	"./Walkabout/Objects/TopFloorObjects/laundry.png": 406,
	"./Walkabout/Objects/TopFloorObjects/lonely_figure.png": 407,
	"./Walkabout/Objects/TopFloorObjects/meatchops.jpg": 408,
	"./Walkabout/Objects/TopFloorObjects/meatchops.png": 409,
	"./Walkabout/Objects/TopFloorObjects/meatgrinder.jpg": 410,
	"./Walkabout/Objects/TopFloorObjects/meatgrinder.png": 411,
	"./Walkabout/Objects/TopFloorObjects/meatslabs.jpg": 412,
	"./Walkabout/Objects/TopFloorObjects/meatslabs.png": 413,
	"./Walkabout/Objects/TopFloorObjects/metalingots.png": 414,
	"./Walkabout/Objects/TopFloorObjects/mirror.png": 415,
	"./Walkabout/Objects/TopFloorObjects/morewine.png": 416,
	"./Walkabout/Objects/TopFloorObjects/mushrooms.png": 417,
	"./Walkabout/Objects/TopFloorObjects/necklace.png": 418,
	"./Walkabout/Objects/TopFloorObjects/obelisk.png": 419,
	"./Walkabout/Objects/TopFloorObjects/pickax.png": 420,
	"./Walkabout/Objects/TopFloorObjects/pileofgold1.png": 421,
	"./Walkabout/Objects/TopFloorObjects/pileofgold2.png": 422,
	"./Walkabout/Objects/TopFloorObjects/pileofgoldsmaller.png": 423,
	"./Walkabout/Objects/TopFloorObjects/pinetree.png": 424,
	"./Walkabout/Objects/TopFloorObjects/pit.png": 425,
	"./Walkabout/Objects/TopFloorObjects/pit2.png": 426,
	"./Walkabout/Objects/TopFloorObjects/plates.png": 427,
	"./Walkabout/Objects/TopFloorObjects/princessbed.png": 428,
	"./Walkabout/Objects/TopFloorObjects/printer.png": 429,
	"./Walkabout/Objects/TopFloorObjects/questboard.png": 430,
	"./Walkabout/Objects/TopFloorObjects/rocks.png": 431,
	"./Walkabout/Objects/TopFloorObjects/ruined_honey.png": 432,
	"./Walkabout/Objects/TopFloorObjects/ruined_wasp_nest.png": 433,
	"./Walkabout/Objects/TopFloorObjects/scarecrow.png": 434,
	"./Walkabout/Objects/TopFloorObjects/scarecrow2.png": 435,
	"./Walkabout/Objects/TopFloorObjects/science.png": 436,
	"./Walkabout/Objects/TopFloorObjects/scrolls.png": 437,
	"./Walkabout/Objects/TopFloorObjects/shittycot.png": 438,
	"./Walkabout/Objects/TopFloorObjects/shortbrownrocks.png": 439,
	"./Walkabout/Objects/TopFloorObjects/shortglacier.png": 440,
	"./Walkabout/Objects/TopFloorObjects/shortrocks.png": 441,
	"./Walkabout/Objects/TopFloorObjects/shovel.png": 442,
	"./Walkabout/Objects/TopFloorObjects/skeleton1.png": 443,
	"./Walkabout/Objects/TopFloorObjects/skeleton2.png": 444,
	"./Walkabout/Objects/TopFloorObjects/skeletons.png": 445,
	"./Walkabout/Objects/TopFloorObjects/skull.png": 446,
	"./Walkabout/Objects/TopFloorObjects/skull2.png": 447,
	"./Walkabout/Objects/TopFloorObjects/skull3.png": 448,
	"./Walkabout/Objects/TopFloorObjects/smallbookshelf.png": 449,
	"./Walkabout/Objects/TopFloorObjects/smallgoldpile.png": 450,
	"./Walkabout/Objects/TopFloorObjects/snowman.png": 451,
	"./Walkabout/Objects/TopFloorObjects/snowtree.png": 452,
	"./Walkabout/Objects/TopFloorObjects/snowtree2.png": 453,
	"./Walkabout/Objects/TopFloorObjects/stairs.png": 454,
	"./Walkabout/Objects/TopFloorObjects/stumpwithax.png": 455,
	"./Walkabout/Objects/TopFloorObjects/swordanvil.png": 456,
	"./Walkabout/Objects/TopFloorObjects/swords.png": 457,
	"./Walkabout/Objects/TopFloorObjects/tallpottedplant.png": 458,
	"./Walkabout/Objects/TopFloorObjects/teachustheinsides.png": 459,
	"./Walkabout/Objects/TopFloorObjects/teapot.png": 460,
	"./Walkabout/Objects/TopFloorObjects/throne.png": 461,
	"./Walkabout/Objects/TopFloorObjects/toyarmy.png": 462,
	"./Walkabout/Objects/TopFloorObjects/toybox.png": 463,
	"./Walkabout/Objects/TopFloorObjects/toydummerboy.png": 464,
	"./Walkabout/Objects/TopFloorObjects/toyregiment.png": 465,
	"./Walkabout/Objects/TopFloorObjects/toyshelves.png": 466,
	"./Walkabout/Objects/TopFloorObjects/toysoldierlarge.png": 467,
	"./Walkabout/Objects/TopFloorObjects/toysoldiersmall.png": 468,
	"./Walkabout/Objects/TopFloorObjects/toytrain.png": 469,
	"./Walkabout/Objects/TopFloorObjects/turkey.png": 470,
	"./Walkabout/Objects/TopFloorObjects/violentbed.png": 471,
	"./Walkabout/Objects/TopFloorObjects/washing.png": 472,
	"./Walkabout/Objects/TopFloorObjects/wasp.png": 473,
	"./Walkabout/Objects/TopFloorObjects/waspnest1.png": 474,
	"./Walkabout/Objects/TopFloorObjects/waspnest2.png": 475,
	"./Walkabout/Objects/TopFloorObjects/waspnest3.png": 476,
	"./Walkabout/Objects/TopFloorObjects/webbarrell.png": 477,
	"./Walkabout/Objects/TopFloorObjects/webbing.png": 478,
	"./Walkabout/Objects/TopFloorObjects/webbing3.png": 479,
	"./Walkabout/Objects/TopFloorObjects/webbing4.png": 480,
	"./Walkabout/Objects/TopFloorObjects/webbooks.png": 481,
	"./Walkabout/Objects/TopFloorObjects/webdragon.png": 482,
	"./Walkabout/Objects/TopFloorObjects/webeggs.png": 483,
	"./Walkabout/Objects/TopFloorObjects/webflower.png": 484,
	"./Walkabout/Objects/TopFloorObjects/webfortune.png": 485,
	"./Walkabout/Objects/TopFloorObjects/webjam.png": 486,
	"./Walkabout/Objects/TopFloorObjects/webjars.png": 487,
	"./Walkabout/Objects/TopFloorObjects/webmoney.png": 488,
	"./Walkabout/Objects/TopFloorObjects/webooks.png": 489,
	"./Walkabout/Objects/TopFloorObjects/weborgan.png": 490,
	"./Walkabout/Objects/TopFloorObjects/webpot.png": 491,
	"./Walkabout/Objects/TopFloorObjects/webscrolls.png": 492,
	"./Walkabout/Objects/TopFloorObjects/webshelves.png": 493,
	"./Walkabout/Objects/TopFloorObjects/webshield.png": 494,
	"./Walkabout/Objects/TopFloorObjects/websword1.png": 495,
	"./Walkabout/Objects/TopFloorObjects/websword2.png": 496,
	"./Walkabout/Objects/TopFloorObjects/webswords.png": 497,
	"./Walkabout/Objects/TopFloorObjects/webtable.png": 498,
	"./Walkabout/Objects/TopFloorObjects/webtable2.png": 499,
	"./Walkabout/Objects/TopFloorObjects/webtable3.png": 500,
	"./Walkabout/Objects/TopFloorObjects/webthrone.png": 501,
	"./Walkabout/Objects/TopFloorObjects/webvanity.png": 502,
	"./Walkabout/Objects/TopFloorObjects/webwine.png": 503,
	"./Walkabout/Objects/TopFloorObjects/webwine2.png": 504,
	"./Walkabout/Objects/TopFloorObjects/webzampiano.png": 505,
	"./Walkabout/Objects/TopFloorObjects/well.png": 506,
	"./Walkabout/Objects/TopFloorObjects/wildflowers.png": 507,
	"./Walkabout/Objects/TopFloorObjects/wine.png": 508,
	"./Walkabout/Objects/TopFloorObjects/wine2.png": 509,
	"./Walkabout/Objects/TopFloorObjects/wineshelves.png": 510,
	"./Walkabout/Objects/TopFloorObjects/writingtablet.png": 511,
	"./Walkabout/Objects/TopFloorObjects/yellowflowers.png": 512,
	"./Walkabout/Objects/TopFloorObjects/zampanio_flowerkid_by_hex2.png": 513,
	"./Walkabout/Objects/TopFloorObjects/zap_object.png": 514,
	"./Walkabout/Objects/UnderFloorObjects/Minotaur.png": 515,
	"./Walkabout/Objects/UnderFloorObjects/Minotaur2.png": 516,
	"./Walkabout/Objects/UnderFloorObjects/NotMinotaur.png": 517,
	"./Walkabout/Objects/UnderFloorObjects/bees.png": 518,
	"./Walkabout/Objects/UnderFloorObjects/bees2.png": 519,
	"./Walkabout/Objects/UnderFloorObjects/bees3.png": 520,
	"./Walkabout/Objects/UnderFloorObjects/bees4.png": 521,
	"./Walkabout/Objects/UnderFloorObjects/blood1.png": 522,
	"./Walkabout/Objects/UnderFloorObjects/blood2.png": 523,
	"./Walkabout/Objects/UnderFloorObjects/blood3.png": 524,
	"./Walkabout/Objects/UnderFloorObjects/blood4.png": 525,
	"./Walkabout/Objects/UnderFloorObjects/blood5.png": 526,
	"./Walkabout/Objects/UnderFloorObjects/bloodpuddle.png": 527,
	"./Walkabout/Objects/UnderFloorObjects/darkhole.png": 528,
	"./Walkabout/Objects/UnderFloorObjects/dirthole.png": 529,
	"./Walkabout/Objects/UnderFloorObjects/filledhole.png": 530,
	"./Walkabout/Objects/UnderFloorObjects/grate.png": 531,
	"./Walkabout/Objects/UnderFloorObjects/paper.png": 532,
	"./Walkabout/Objects/UnderFloorObjects/puddle.png": 533,
	"./Walkabout/Objects/UnderFloorObjects/rabbithole.png": 534,
	"./Walkabout/Objects/UnderFloorObjects/webbing.png": 535,
	"./Walkabout/Objects/UnderFloorObjects/webbing3.png": 536,
	"./Walkabout/Objects/UnderFloorObjects/webbing4.png": 537,
	"./Walkabout/Objects/UnderFloorObjects/webbing5.png": 538,
	"./Walkabout/Objects/air_vent.png": 539,
	"./Walkabout/Objects/bees.png": 540,
	"./Walkabout/Objects/blood3.jfif": 541,
	"./Walkabout/Objects/bones.png": 542,
	"./Walkabout/Objects/g3GlTUN.png": 543,
	"./Walkabout/Objects/hunt.png": 544,
	"./Walkabout/Objects/plants.png": 545,
	"./Walkabout/Objects/spookywebdoor.png": 546,
	"./Walkabout/Sprites/Apocalypse_Crow.gif": 547,
	"./Walkabout/Sprites/Apocalypse_Crow2.gif": 548,
	"./Walkabout/Sprites/Art_Object_ghoul.gif": 549,
	"./Walkabout/Sprites/Space_object_ghoul.gif": 550,
	"./Walkabout/Sprites/Twisting_Crow.gif": 551,
	"./Walkabout/Sprites/clockface_sheet_by_hex.png": 552,
	"./Walkabout/Sprites/clockface_walk_down.gif": 553,
	"./Walkabout/Sprites/clockface_walk_left.gif": 554,
	"./Walkabout/Sprites/clockface_walk_right.gif": 555,
	"./Walkabout/Sprites/clockface_walk_up.gif": 556,
	"./Walkabout/Sprites/flowerkid_walk_down.gif": 557,
	"./Walkabout/Sprites/flowerkid_walk_left.gif": 558,
	"./Walkabout/Sprites/flowerkid_walk_right.gif": 559,
	"./Walkabout/Sprites/flowerkid_walk_up.gif": 560,
	"./Walkabout/Sprites/humanoid_crow.gif": 561,
	"./Walkabout/Sprites/hunter_by_ghoul.png": 562,
	"./Walkabout/Sprites/hunter_walk_down.gif": 563,
	"./Walkabout/Sprites/hunter_walk_left.gif": 564,
	"./Walkabout/Sprites/hunter_walk_right.gif": 565,
	"./Walkabout/Sprites/hunter_walk_up.gif": 566,
	"./Walkabout/Sprites/plushie_shark_swimmin.gif": 567,
	"./Walkabout/Sprites/technology_object_ghoul.gif": 568,
	"./Walkabout/Sprites/unknown.png": 569,
	"./Walkabout/Sprites/zampanio_flowerkid_by_hex.png": 570,
	"./Walkabout/Sprites/zampanio_flowerkid_by_hex2.png": 571,
	"./Walkabout/balls.png": 572,
	"./Walkabout/bones.png": 573,
	"./Walkabout/butcherparts.png": 574,
	"./Walkabout/coffin.png": 575,
	"./Walkabout/computers.png": 576,
	"./Walkabout/computers2.png": 577,
	"./Walkabout/crystals.png": 578,
	"./Walkabout/door.png": 579,
	"./Walkabout/doors.png": 580,
	"./Walkabout/elements.png": 581,
	"./Walkabout/fire.png": 582,
	"./Walkabout/floor/arcanefloor.png": 583,
	"./Walkabout/floor/arcanefloor2.png": 584,
	"./Walkabout/floor/brickfloor.png": 585,
	"./Walkabout/floor/brickfloor2.png": 586,
	"./Walkabout/floor/brickfloor3.png": 587,
	"./Walkabout/floor/carpetfloor.png": 588,
	"./Walkabout/floor/chessfloor.png": 589,
	"./Walkabout/floor/chevronfloor.png": 590,
	"./Walkabout/floor/clouds.png": 591,
	"./Walkabout/floor/cobblestonefloor.png": 592,
	"./Walkabout/floor/corruptionfloor.png": 593,
	"./Walkabout/floor/curtains.png": 594,
	"./Walkabout/floor/dirtfloor.png": 595,
	"./Walkabout/floor/dirtstonefloor.png": 596,
	"./Walkabout/floor/fancywoodfloor.png": 597,
	"./Walkabout/floor/firefloor.png": 598,
	"./Walkabout/floor/flesh.png": 599,
	"./Walkabout/floor/flesh2.png": 600,
	"./Walkabout/floor/flesh3.png": 601,
	"./Walkabout/floor/geometricfloor.png": 602,
	"./Walkabout/floor/glassfloor.png": 603,
	"./Walkabout/floor/goldwalls.png": 604,
	"./Walkabout/floor/grassfloor.png": 605,
	"./Walkabout/floor/gratefloor.png": 606,
	"./Walkabout/floor/icefloor.png": 607,
	"./Walkabout/floor/lavafloor.png": 608,
	"./Walkabout/floor/lightfloor.png": 609,
	"./Walkabout/floor/metalboardfloor.png": 610,
	"./Walkabout/floor/metalfloor.png": 611,
	"./Walkabout/floor/metalfloor2.png": 612,
	"./Walkabout/floor/metaltilefloor.png": 613,
	"./Walkabout/floor/snow.png": 614,
	"./Walkabout/floor/spiral.png": 615,
	"./Walkabout/floor/stars.png": 616,
	"./Walkabout/floor/static.png": 617,
	"./Walkabout/floor/stonefloor.png": 618,
	"./Walkabout/floor/tilefloor.png": 619,
	"./Walkabout/floor/vines.png": 620,
	"./Walkabout/floor/voidfloor.png": 621,
	"./Walkabout/floor/waterfloor.png": 622,
	"./Walkabout/floor/waterfloor2.png": 623,
	"./Walkabout/floor/waterfloor3.png": 624,
	"./Walkabout/floor/web.png": 625,
	"./Walkabout/floor/weirdfloor.png": 626,
	"./Walkabout/floor/woodfloor.png": 627,
	"./Walkabout/floor/wovenfloor.png": 628,
	"./Walkabout/floor/yellowwallpaper.jpg": 629,
	"./Walkabout/icons8-chat-64.png": 630,
	"./Walkabout/icons8-chat-64_green.png": 631,
	"./Walkabout/icons8-x-50.png": 632,
	"./Walkabout/in_body_a2_by_cvrtis-da7k69a.png": 633,
	"./Walkabout/in_body_a4_by_cvrtis-da7tk3w.png": 634,
	"./Walkabout/kitchen.png": 635,
	"./Walkabout/nidhogg_flower.png": 636,
	"./Walkabout/oh_god.png": 637,
	"./Walkabout/oh_god2.png": 638,
	"./Walkabout/ohgod_3.png": 639,
	"./Walkabout/piano.png": 640,
	"./Walkabout/request_march_by_nicnubill_d7a6dq7.png": 641,
	"./Walkabout/rocks.png": 642,
	"./Walkabout/rpgmaker.png": 643,
	"./Walkabout/rug.png": 644,
	"./Walkabout/wall/blackboard.png": 645,
	"./Walkabout/wall/bloodywall.png": 646,
	"./Walkabout/wall/books.png": 647,
	"./Walkabout/wall/brickwalls.png": 648,
	"./Walkabout/wall/circus.png": 649,
	"./Walkabout/wall/clouds.png": 650,
	"./Walkabout/wall/curtains.png": 651,
	"./Walkabout/wall/darkcorruption.png": 652,
	"./Walkabout/wall/dirtwall.png": 653,
	"./Walkabout/wall/flesh.png": 654,
	"./Walkabout/wall/flesh2.png": 655,
	"./Walkabout/wall/goldwalls.png": 656,
	"./Walkabout/wall/hedgewall.png": 657,
	"./Walkabout/wall/jail.png": 658,
	"./Walkabout/wall/lavawall.png": 659,
	"./Walkabout/wall/leafwalls.png": 660,
	"./Walkabout/wall/lightwall.png": 661,
	"./Walkabout/wall/logwalls.png": 662,
	"./Walkabout/wall/metalwall1.png": 663,
	"./Walkabout/wall/metalwall2.png": 664,
	"./Walkabout/wall/metalwall3.png": 665,
	"./Walkabout/wall/pinetrees.png": 666,
	"./Walkabout/wall/roses.png": 667,
	"./Walkabout/wall/snowyforest.png": 668,
	"./Walkabout/wall/spiral.png": 669,
	"./Walkabout/wall/stars.png": 670,
	"./Walkabout/wall/stonewalls.png": 671,
	"./Walkabout/wall/stonewalls2.png": 672,
	"./Walkabout/wall/tattered_curtains.png": 673,
	"./Walkabout/wall/thatchwalls.png": 674,
	"./Walkabout/wall/tilewall.png": 675,
	"./Walkabout/wall/waterwall.png": 676,
	"./Walkabout/wall/web.png": 677,
	"./Walkabout/wall/woodwall.png": 678,
	"./Walkabout/wall/yellowwallpaper.jpg": 679,
	"./Walkabout/wandacoffin.png": 680,
	"./Walkabout/web.png": 681,
	"./Walkabout/web2.png": 682,
	"./approved.gif": 67,
	"./aviary.png": 683,
	"./aviary2.png": 684,
	"./background.jpg": 54,
	"./bookbg.jpg": 685,
	"./chair.png": 686,
	"./dreamstime_s_107263084.jpg": 687,
	"./dreamstime_s_119442663.jpg": 688,
	"./dreamstime_s_143818783.jpg": 689,
	"./dreamstime_s_20658184.jpg": 690,
	"./dreamstime_s_22464803.jpg": 691,
	"./dreamstime_s_23278565.jpg": 692,
	"./dreamstime_s_25350097.jpg": 693,
	"./dreamstime_s_36310251.jpg": 694,
	"./dreamstime_s_37910249.jpg": 695,
	"./dreamstime_s_37965548.jpg": 696,
	"./dreamstime_s_66614814.jpg": 697,
	"./dreamstime_s_82823450.jpg": 698,
	"./dreamstime_s_83560464.jpg": 699,
	"./dreamstime_s_87359540.jpg": 700,
	"./dreamstime_s_87359979.jpg": 701,
	"./dreamstime_s_98438134.jpg": 702,
	"./dreamstime_s_98716328.jpg": 703,
	"./dreamstime_xs_106176433.jpg": 704,
	"./eye1.png": 68,
	"./eye2.png": 69,
	"./falseJR.png": 705,
	"./five.jpg": 706,
	"./four.jpg": 707,
	"./humanoid_crow.gif": 708,
	"./jr.png": 709,
	"./jrlobsteronchair.png": 710,
	"./logo.png": 711,
	"./meadow.jpg": 712,
	"./monsters/NotAMinotaur/0.png": 713,
	"./monsters/NotAMinotaur/1.png": 714,
	"./monsters/NotAMinotaur/2.png": 715,
	"./monsters/NotAMinotaur/3.png": 716,
	"./monsters/doll/1.png": 717,
	"./monsters/doll/1left.png": 718,
	"./monsters/doll/doll.png": 719,
	"./monsters/eye/eye.png": 720,
	"./monsters/fog/fog.png": 721,
	"./monsters/notminotaur.png": 722,
	"./monsters/orb.png": 723,
	"./monsters/seagull/skelly_0001.png": 724,
	"./monsters/seagull/skelly_0002.png": 725,
	"./monsters/seagull/skelly_0003.png": 726,
	"./monsters/seagull/skelly_0004.png": 727,
	"./monsters/seagull/skelly_0005.png": 728,
	"./monsters/seagull/skelly_0006.png": 729,
	"./monsters/seagull/skelly_0007.png": 730,
	"./monsters/seagull/skelly_0008.png": 731,
	"./monsters/skullweb/skull_web.png": 732,
	"./monsters/tech/1.png": 733,
	"./monsters/tech/1left.png": 734,
	"./monsters/tech/2.png": 735,
	"./monsters/tech/2left.png": 736,
	"./monsters/tech/3.png": 737,
	"./monsters/tech/3left.png": 738,
	"./monsters/tech/4.png": 739,
	"./monsters/tech/4left.png": 740,
	"./monsters/tech/techmonster.png": 741,
	"./monsters/wattlaugh.gif": 742,
	"./murderbasement.jpeg": 743,
	"./murderbasement2.jpeg": 744,
	"./murderbasementsource.jpeg": 745,
	"./nidhogg_flower.png": 66,
	"./notaminotaur.png": 746,
	"./one.jpg": 747,
	"./probablyYou.png": 748,
	"./real_eye.png": 55,
	"./room1.jpg": 749,
	"./room2.jpg": 750,
	"./sandfloor.png": 751,
	"./server.png": 752,
	"./server1.jpeg": 753,
	"./spinningLogoReal.gif": 754,
	"./src - Shortcut.lnk": 755,
	"./terriblecycle.PNG": 756,
	"./three.jpg": 757,
	"./tunnel2.jpg": 758,
	"./tunnel3.jpg": 759,
	"./tunnel4.jpeg": 760,
	"./tunnel5.jpeg": 761,
	"./tunnel6.jpg": 762,
	"./wanda.png": 763,
	"./weaversgift.png": 764,
	"./weirdlythistiesintoanactualcanonthing_so_horsehoes.PNG": 765
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 115;